const KEY_PREFIX = 'trustedDevice_';

/** Build a stable per-user key from id/email-like candidates. */
export function getTrustedDeviceUserKey(
  ...candidates: (string | null | undefined)[]
): string {
  const value = candidates
    .map((candidate) => candidate?.trim() ?? '')
    .find(Boolean);
  if (!value) return '';
  // Normalize email casing while keeping opaque IDs untouched.
  return value.includes('@') ? value.toLowerCase() : value;
}

/**
 * Checks if the current browser has been marked as trusted for a given user.
 * Per-browser by nature (localStorage) and per-user via key prefix.
 */
export function isDeviceTrustedLocally(userId: string): boolean {
  if (!userId) return false;
  try {
    return localStorage.getItem(`${KEY_PREFIX}${userId}`) === 'true';
  } catch {
    return false;
  }
}

export function setDeviceTrustedLocally(
  userId: string,
  trusted: boolean
): void {
  if (!userId) return;
  try {
    if (trusted) {
      localStorage.setItem(`${KEY_PREFIX}${userId}`, 'true');
    } else {
      localStorage.removeItem(`${KEY_PREFIX}${userId}`);
    }
  } catch {
    /* storage unavailable */
  }
}
